import Document_Minimal from './Document_Minimal'
import Document_Version from './Document_Version'
import Document_User from './Document_User'

export default {
    Document_Minimal,
    Document_Version,
    Document_User,
}
